function toggleRadioBoxState(radio: Element): void {
  if (!(radio instanceof HTMLInputElement)) {
    return;
  }

  const label = radio.closest('.radio-box');
  if ('checked' in radio && radio.checked) {
    label?.classList.add('radio-box--checked');
    radio.ariaChecked = 'true';
  } else {
    label?.classList.remove('radio-box--checked');
    radio.ariaChecked = 'false';
  }
}

export function initRadioBoxModule(): void {
  document.addEventListener('change', (e) => {
    const target = e.target;
    if (
      !(target instanceof HTMLInputElement) ||
      !target.matches('.radio-box input[type=radio]')
    ) {
      return;
    }

    document
      .querySelectorAll(`.radio-box input[name=${target?.name}]`)
      .forEach((radio) => {
        radio?.closest('.radio-box')?.classList.remove('radio-box--checked');
        radio?.setAttribute('aria-checked', 'false');
      });
    toggleRadioBoxState(target);
  });

  document.querySelectorAll('.radio-box input[type=radio]').forEach((radio) => {
    toggleRadioBoxState(radio);
  });
}
